import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "The sun does the work",
    body: "Six to eight hours of daylight is all it takes. LumaDeck drinks in the sun by day and gives it back as warm light by night — no wiring, no switches, no electricity bill.",
  },
  {
    n: "02",
    title: "Warm by design",
    body: "A 2700K warm-white glow — the colour of candlelight and long evenings. Stainless steel and ABS, shaped to disappear into your space by day and define it by night.",
  },
  {
    n: "03",
    title: "Built for the outdoors",
    body: "IP65 sealed against rain, dust, and the odd garden hose. Screw it down or stick it on — then forget about it for years. Every pack is covered by a 1-year warranty.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="py-32 sm:py-40" data-testid="manifesto-section">
    <div className="max-w-5xl mx-auto px-6 sm:px-10">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
        className="text-xs uppercase tracking-[0.3em] text-amber-400 mb-20"
      >
        The LumaDeck manifesto
      </motion.p>

      <div className="space-y-28">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-120px" }}
            transition={{ duration: 0.9, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="grid grid-cols-12 gap-6 items-start"
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <div className="col-span-3 sm:col-span-2">
              <span className="font-serif text-6xl sm:text-7xl text-amber-400/20">{c.n}</span>
            </div>
            <div className="col-span-9 sm:col-span-10">
              <h3 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-stone-50 mb-5">
                {c.title}
              </h3>
              <p className="text-stone-400 text-base sm:text-lg leading-relaxed max-w-xl">{c.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
